import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import WhatsAppEmbeddedSignupWebhookRequest from "../request/WhatsAppEmbeddedSignupWebhookRequest";
import WhatsAppEmbeddedSignupWebhookResponse from "../model/WhatsAppEmbeddedSignupWebhookResponse";
import WhatsAppEmbeddedSignupWebhookErrorResponse from "../model/WhatsAppEmbeddedSignupWebhookErrorResponse";
import { queryClient } from "../../../../App";

const WhatsAppEmbeddedSignupWebhookApiService = async (
  request: WhatsAppEmbeddedSignupWebhookRequest
): Promise<WhatsAppEmbeddedSignupWebhookResponse> => {
  const url = "/whatsapp_embedded_signup_webhook/";
  const { data } = await axios.post(url, request, {
    headers: {
      "Cache-Control": "no-cache, no-store, must-revalidate",
      Pragma: "no-cache",
      Expires: "0",
    },
  });
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useWhatsAppEmbeddedSignupWebhookApiService = () =>
  useMutation<
    WhatsAppEmbeddedSignupWebhookResponse,
    AxiosError<WhatsAppEmbeddedSignupWebhookErrorResponse>,
    WhatsAppEmbeddedSignupWebhookRequest
  >(WhatsAppEmbeddedSignupWebhookApiService, {
    mutationKey: "WhatsAppEmbeddedSignupWebhookApiService",
    onSuccess: () => {
      queryClient.invalidateQueries([
        "WhatsAppEmbeddedSignupJobStatusApiService",
      ]);
    },
  });

export {
  WhatsAppEmbeddedSignupWebhookApiService,
  useWhatsAppEmbeddedSignupWebhookApiService,
};
